import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule } from '@ngneat/transloco';
import { SharedModule } from 'app/shared/shared.module';
import { UnitSelectionDialogComponent } from './unit-selection-dialog.component';

@NgModule({
    declarations: [UnitSelectionDialogComponent],
    imports: [
        SharedModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatSelectModule,
        TranslocoModule,
    ],
})
export class UnitSelectionDialogModule {}
